export default __webpack_public_path__ + "static/media/Scholar's Armbands of the Burning Disc.352859c5.jpg";